import React from "react";
import banner from "../assets/img/our-store-page/our-store-banner.jpg";
import mobile from "../assets/img/our-store-page/store-mobile-banner.jpg";

import { Container } from "react-bootstrap";
const OurStoreBanner = () => {
  return (
    <>
      <section>
        <Container fluid className="bannersection position-relative p-0">
          <img
            src={window.innerWidth > 568 ? banner : mobile}
            alt="Service banner"
            className="w-100  h-100 object-fit-cover about-banner-img"
          />
          <div className="textoverlay pt-5 d-flex flex-column justify-content-center align-items-center position-absolute top-0 w-100 h-100 text-center">
            {/* <h1 className="heading">
              The Evolution of Diamond Quality Assessment
            </h1> */}
          </div>
        </Container>
      </section>
    </>
  );
};

export default OurStoreBanner;
